import { createSlice } from '@reduxjs/toolkit'

import { getDevicePolicyAPI } from '@/api/shop'
import { addMessage } from '@/components/messages/messagesActions'

export const NAME = 'device-policy'
// @ts-ignore
export const getDevicePolicy = phoneNumber => async (dispatch, getState) => {
  if (getIsLoading(getState())) return

  dispatch(loading())

  try {
    const devicePolicy = await getDevicePolicyAPI(phoneNumber)
    dispatch(success(devicePolicy))
    // @ts-ignore
    if (devicePolicy.settings.device_policy_message) {
      // @ts-ignore
      dispatch(addMessage('Søk om ny mobil', devicePolicy.settings.device_policy_message, true))
    }
  } catch (error) {
    dispatch(failure(error))
  }
}
// @ts-ignore
const devicesFromInventory = inventory => {
  // @ts-ignore
  let devices = []
  // @ts-ignore
  inventory.forEach(item => {
    // @ts-ignore
    if (devices.indexOf(item.device) === -1) devices.push(item.device)
  })
  // @ts-ignore
  return devices
}
// @ts-ignore
const modelsFromInventory = inventory => {
  const models = {}
  // @ts-ignore
  inventory.forEach(item => {
    // @ts-ignore
    let device = models[item.device]
    if (!device) {
      device = []
      // @ts-ignore
      models[item.device] = device
    }
    device.push(item)
  })
  return models
}

const initialState = {
  isLoading: false,
  isLoaded: false,
  error: undefined,
  devices: [],
  models: [],
  settings: {},
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    loading: state => {
      state.error = undefined
      state.isLoading = true
    },
    success: (state, { payload: devicePolicy }) => {
      const { settings, inventory } = devicePolicy
      state.isLoading = false
      state.isLoaded = true
      state.settings = settings
      // @ts-ignore
      state.devices = devicesFromInventory(inventory)
      // @ts-ignore
      state.models = modelsFromInventory(inventory)
      // @ts-ignore
      state.inventory = inventory
    },
    failure: (state, { payload: error }) => {
      state.error = error
      state.isLoading = false
      state.isLoaded = true
    },
    reset: () => ({ ...initialState }),
  },
})

export const { loading, success, failure, reset } = actions
export default reducer
// @ts-ignore
const getState = state => state[NAME]

export const getIsLoaded = (state: any) => getState(state).isLoaded
export const getIsLoading = (state: any) => getState(state).isLoading && !getIsLoaded(state)
export const getError = (state: any) => getState(state).error

export const getSettings = (state: any) => getState(state).settings
export const getInventory = (state: any) => getState(state).inventory
export const getDevices = (state: any) => getState(state).devices
export const getModels = (state: any) => getState(state).models

export const getAsset = (state: any) => getSettings(state)?.asset

export const getIsBuyoutAvailable = (state: any) =>
  Boolean(getAsset(state)?.recieved) && getSettings(state)?.allow_asset_buyout
export const getIsArbitraryBuyoutAvailable = (state: any) =>
  Boolean(getAsset(state)?.recieved) && getSettings(state)?.allow_arbitrary_asset_buyout
